// extracted by mini-css-extract-plugin
export var indicator = "languageDropdown-module--indicator--d6a86";